import { Microphone, MicrophoneSlash } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useMicrophonePermission from "common/hooks/useMicrophonePermission";

interface RecordButtonProps {
  isRecording: boolean;
  setIsRecording: (isRecording: boolean) => void;
  size?: "xs" | "sm" | "md" | "lg";
  isDisabled?: boolean;
}

export default function RecordButton({
  isRecording,
  setIsRecording,
  size = "md",
  isDisabled = false,
}: RecordButtonProps) {
  const { hasPermission, requestPermission } = useMicrophonePermission();

  const recordButton = (
    <Button
      size={size}
      intent="iconOnly"
      disabled={isDisabled}
      variant={isRecording ? "secondary-black" : "ghost-black"}
      onClick={() => {
        requestPermission().then(() => {
          setIsRecording(!isRecording);
        });
      }}
    >
      {hasPermission ? <Microphone /> : <MicrophoneSlash />}
    </Button>
  );

  if (!hasPermission) {
    return (
      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>{recordButton}</TooltipTrigger>

          <TooltipContent>
            Please enable microphone access in your browser settings to
            continue.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return recordButton;
}
